/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="standingBlocks.module.ts" />

module Meevo.Plugins.StandingBlocks {
	class StandingBlocksController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

		static $inject = [
			"meevo.AppSettings",
			"meevo.components.common.DataService",
			"meevo.components.modal.ModalService",
			"meevo.components.common.IdentityService",
			"meevo.components.logging.LoggingService",
			"meevo.components.common.SecurityService",
			"meevo.components.tracking.TrackingService",
			"$rootScope",
			"$scope",
			"$state",
			"meevo.ContextParams",
			'meevo.components.short-cuts.ShortCutsService',
			"Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService",
			"$q",
			"meevo.components.busy.BusyService",
			"meevo.components.common.durationIncrementsService"
		];

		constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
			protected dataService: Meevo.Components.BaseClasses.IDataService,
			protected modalService: Meevo.Components.Modal.IModalService,
			protected identityService: Meevo.Components.Common.IIdentityService,
			protected loggingService: Meevo.Components.Logging.ILoggingService,
			protected securityService: Meevo.Components.Common.ISecurityService,
			protected trackingService: Meevo.Components.Tracking.ITrackingService,
			protected $rootScope: angular.IRootScopeService,
			protected $scope: angular.IScope,
			protected $state: any,
			protected contextParams: Meevo.IContextParams,
			protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
			protected appointmentBookModalService: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService,
			protected $q: angular.IQService,

			protected busyService: Meevo.Components.Busy.IBusyService,
			protected durationIncrements) {

			super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);


		}

		/**
		* Creates the context for editing/adding an item.
		* @return {}
		*/
		createContext(): void {
			let rc = this;
			rc.busyService.start();
			rc.securityService.checkSection(rc.meevoSecurityKeys.APPOINTMENTS_BLOCKDEFINITION)
				.then(() => {
					this.context = new StandingBlocksContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.appointmentBookModalService, this.$q, this.durationIncrements);
					super.createContext();
					this.context.activate(this.selectedItemId);
					this.context.deactivate = () => {
						this.visualState = Model.MaintenanceFormVisualState.Search;
					}
				}).catch(() => {
					rc.busyService.stop();
				}).finally(() => {
					rc.busyService.stop();
				});
		}


	}

	angular.module("meevo.plugins.standingBlocks")
		.controller("meevo.plugins.standingBlocks.StandingBlocksController", StandingBlocksController);
}
